import React from 'react';
import { connect } from 'react-redux';
import {
  FlatButton,
  Dialog,
  Tabs,
  Tab,
  ListItem,
  List,
  CircularProgress,
} from 'material-ui';
import Preview from 'material-ui/svg-icons/hardware/phone-iphone';

import { callApi } from '../client/apiToolbox';
import { API_BASE_URL } from '../App';
import { getSoapiTranslationByLocale } from '../utils/TranslationUtils';
import { formatPrice } from '../utils/NumberUtils';

const styles = {
  dialog: {
    content: {
      width: '425px',
      height: '720px',
    },
    paper: {
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    body: {
      height: '100%',
      maxHeight: '100%',
      overflow: 'visible',
      padding: 0,
    },
  },
  product: {
    listItem: {
      overflow: 'hidden',
      height: '140px',
    },
    image: {
      top: '-60px',
      left: 0,
      width: 'calc(100% - 18px)',
    },
    overlay: {
      display: 'block',
      width: 'calc(100% - 18px)',
      top: '0',
      left: '0',
      position: 'absolute',
      padding: '1em',
      boxSizing: 'border-box',
      color: 'white',
      background: 'rgba(0,0,0,0.29)',
      minHeight: '140px',
    },
  },
  overlay: {
    title: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
};

class VenuePreview extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if ((!this.props.data && nextProps.data) || (this.props.data && !this.state.assortmentName)) {
      this.setState({ assortmentName: nextProps.data.name });
    }
  };

  fetchAssortment = (name) => {
    this.setState({ fetching: true });
    callApi(`${API_BASE_URL}/ext/soapi/assortment/${name}`, 'GET')
      .then(({ json }) => {
        this.setState({ assortment: json, fetching: false, open: true });
      });
  };

  toggle = () => this.setState({ open: !this.state.open });

  render() {
    const { open, assortment, assortmentName } = this.state;
    const { locale } = this.props;
    return (
      <FlatButton
        onClick={() => this.fetchAssortment(assortmentName)}
        primary
        label="Preview"
        icon={this.state.fetching ? <CircularProgress size={20} /> : <Preview />}
      >
        <Dialog
          open={open}
          onRequestClose={this.toggle}
          contentStyle={styles.dialog.content}
          paperProps={{ style: styles.dialog.paper }}
          bodyStyle={styles.dialog.body}
        >
          {assortment && assortment.categories && assortment.categories.length > 0 ?
            <Tabs>
              {assortment.categories.map((mainCategory) => (
                <Tab
                  key={getSoapiTranslationByLocale(mainCategory.name.translations, locale)}
                  label={getSoapiTranslationByLocale(mainCategory.name.translations, locale)}
                >
                  {mainCategory &&
                    <List>
                      {mainCategory.categories.map((subCategory) => (
                        <ListItem
                          key={getSoapiTranslationByLocale(subCategory.name.translations, locale)}
                          primaryText={getSoapiTranslationByLocale(subCategory.name.translations, locale)}
                          initiallyOpen
                          nestedItems={
                            subCategory.products &&
                              subCategory.products.map((product) => (
                                <ListItem
                                  key={product.id}
                                  primaryText={
                                    <span style={styles.product.overlay}>
                                      <div style={styles.overlay.title}>
                                        <h4>{getSoapiTranslationByLocale(product.name.translations, locale)}</h4> <h5>{formatPrice(product.price.value, product.price.precision)}</h5>
                                      </div>
                                      <h6 style={{ marginTop: 0 }}>{getSoapiTranslationByLocale(product.description.translations, locale)}</h6>
                                    </span>
                                  }
                                  style={styles.product.listItem}
                                  leftAvatar={<img style={styles.product.image} alt="" src={product.imageURIs && product.imageURIs.find((img) => img.tag === 'mainS3').uri} />}
                                />
                              ))
                          }
                        />
                      ))}
                    </List>
                  }
                </Tab>
              ))}
            </Tabs>
            : <h2 style={{ textAlign: 'center' }}>Empty assortment</h2>}
        </Dialog>
      </FlatButton>
    );
  }
}

export default connect()(VenuePreview);
